/**
 * ADS Built-in ItemMaster LPP values
 * Source: ItemMaster CSV (26,556 items) — key items extracted
 * LPP = Last Purchase Price (your cost)
 * Replace/extend via ItemMaster CSV import in the UI
 */
export const ADS_BUILTIN = {
  "AB.CONTACTOR.30A":  { p: "A-B.100-C30D10",        lpp: 58.25 },
  "AB.CONTACTOR.97A":  { p: "A-B.100-C97D10",        lpp: 144.52 },
  "AB.OLR.LARGE":      { p: "A-B.193-1EFFD",         lpp: 76.03 },
  "AB.OLR.75HP":       { p: "A-B.193-1EFGE",         lpp: 88.09 },
  "AB.PSU.24V":        { p: "A-B.1606-XLP100E",      lpp: 303.92 },
  "AB.PSU.960W":       { p: "A-B.1606-XLS960E-3",    lpp: 1203.35 },
  "AB.SWITCH.ENIP":    { p: "A-B.1783-CMS6B",        lpp: 1166.84 },
  "AB.CB.40A":         { p: "A-B.140G-G2C3-C40",     lpp: 154.61 },
  "AB.CB.100A":        { p: "A-B.140G-G2C3-D10",     lpp: 250.61 },
  "SS.15HP":           { p: "MOT.VMX-SGY-I-195",     lpp: 1658.50 },
  "SS.75HP":           { p: "MOT.VMX-SGY-I-302",     lpp: 2491.00 },
  "SS.3HP":            { p: "WEG.SSW050060T2246TPZ",  lpp: 435.84 },
  "VFD.3HP":           { p: "YEC.GA80U4005ABM",      lpp: 500.95 },
  "VFD.15HP":          { p: "YEC.GA80U4023ABM",      lpp: 1211.31 },
  "VFD.75HP":          { p: "YEC.GA80U4089ABM",      lpp: 3943.10 },
  "XFMR.9KVA":        { p: "SE.9070T3000D1",        lpp: 673.25 },
  "XFMR.CPT.1KVA":    { p: "SE.9070TF1000D1",       lpp: 293.20 },
  "SPD":               { p: "RAYC.T2-480-3+0-R",     lpp: 140.00 },
  "METER":             { p: "WAGO.2857-570/024-005",  lpp: 480.20 },
};

/**
 * ItemMaster part number lookup map
 * Key = our internal ADS key
 * Value = array of possible part numbers to search for in the CSV
 */
export const ITEMMASTER_KEY_MAP = {
  "AB.CONTACTOR.30A": ["a-b.100-c30d10", "100-c30d10"],
  "AB.CONTACTOR.97A": ["a-b.100-c97d10", "100-c97d10"],
  "AB.OLR.LARGE":     ["a-b.193-1effd",  "193-1effd"],
  "AB.OLR.75HP":      ["a-b.193-1efge",  "193-1efge"],
  "AB.PSU.24V":       ["a-b.1606-xlp100e", "1606-xlp100e"],
  "AB.PSU.960W":      ["a-b.1606-xls960e-3", "1606-xls960e-3"],
  "AB.SWITCH.ENIP":   ["a-b.1783-cms6b", "1783-cms6b"],
  "AB.CB.40A":        ["a-b.140g-g2c3-c40", "140g-g2c3-c40"],
  "AB.CB.100A":       ["a-b.140g-g2c3-d10", "140g-g2c3-d10"],
  "SS.15HP":          ["mot.vmx-sgy-i-195", "vmx-sgy-i-195"],
  "SS.75HP":          ["mot.vmx-sgy-i-302", "vmx-sgy-i-302"],
  "SS.3HP":           ["weg.ssw050060t2246tpz", "ssw050060t2246tpz"],
  "VFD.3HP":          ["yec.ga80u4005abm", "ga80u4005abm"],
  "VFD.15HP":         ["yec.ga80u4023abm", "ga80u4023abm"],
  "VFD.75HP":         ["yec.ga80u4089abm", "ga80u4089abm"],
  "XFMR.9KVA":       ["se.9070t3000d1", "9070t3000d1"],
  "XFMR.CPT.1KVA":   ["se.9070tf1000d1", "9070tf1000d1"],
  "SPD":              ["rayc.t2-480-3+0-r", "t2-480-3+0-r"],
  "METER":            ["wago.2857-570/024-005", "2857-570/024-005"],
};
